import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=51c836f0&scoped=true&"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&id=51c836f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c836f0",
  null
  
)

export default component.exports